/** @jsx jsx */
import React from 'react'
import { css, jsx } from '@emotion/react'
import Layout from '../components/Layout'
import ThemeWrapper from '../components/Theme'
import { Column, ColumnWrap, ColumnWrapper, Title, Button, Image, Text, FullmapCover, TitleMain, Subtitle } from '@swp/components'


export default function Page(props) {
  return (
    <ThemeWrapper>
      <Layout >
        <Column className="--parallax" name={"uvod"} style={{"marginTop":0,"paddingTop":60,"marginBottom":0,"paddingBottom":57,"backgroundColor":"rgba(255, 255, 255, 1)"}} parallax={true} css={css`
      background-position: 45% 72%;
    `}>
          
          <ColumnWrap className="column__flex js-anim  --anim6 --anim-s5 --center el--1 pb--0 pt--0 flex--center" anim={"6"} animS={"5"} style={{"maxWidth":1410}} columns={"1"}>
            
            <ColumnWrapper className="pb--0 pt--0" style={{"maxWidth":1150}}>
              
              <Title className="title-box title-box--center fs--62 ls--12 pb--0 pl--0 pr--0 pt--0" style={{"maxWidth":1268}} content={"<span style=\"color: var(--black); font-weight: normal;\">LUCIE PÁLKOVÁ</span><br>"}>
              </Title>

              <Title className="title-box title-box--center fs--24 pb--0 pl--0 pr--0 pt--0" style={{"maxWidth":1268}} content={"<span style=\"color: rgb(132, 132, 132);\">P O R T F O L I O<br><span style=\"font-weight: normal;\">G R A P H I C&nbsp; D E S I G N E R</span></span><br>"}>
              </Title>

            </ColumnWrapper>

          </ColumnWrap>

        </Column>


        <Column className="css-1vtrcui --parallax" name={"1c26ndp2rvv"} style={{"paddingTop":17,"paddingBottom":17}} parallax={true} css={css`
      
    background-image: url(https://cdn.swbpg.com/t/23336/4acb2b1b2334460680a8f2bb9d3d6c47_s=350x_.jpeg);
    @media (min-width: 351px) {
      background-image: url(https://cdn.swbpg.com/t/23336/4acb2b1b2334460680a8f2bb9d3d6c47_s=660x_.jpeg);
    }
    @media (min-width: 661px) {
      background-image: url(https://cdn.swbpg.com/t/23336/4acb2b1b2334460680a8f2bb9d3d6c47_s=860x_.jpeg);
    }
    @media (min-width: 861px) {
      background-image: url(https://cdn.swbpg.com/t/23336/4acb2b1b2334460680a8f2bb9d3d6c47_s=1400x_.jpeg);
    }
    @media (min-width: 1401px) {
      background-image: url(https://cdn.swbpg.com/t/23336/4acb2b1b2334460680a8f2bb9d3d6c47_s=2000x_.jpeg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (max-width: 350px) {
      background-image: url(https://cdn.swbpg.com/t/23336/4acb2b1b2334460680a8f2bb9d3d6c47_s=660x_.jpeg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (min-width: 351px) {
      background-image: url(https://cdn.swbpg.com/t/23336/4acb2b1b2334460680a8f2bb9d3d6c47_s=1400x_.jpeg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (min-width: 861px) {
      background-image: url(https://cdn.swbpg.com/t/23336/4acb2b1b2334460680a8f2bb9d3d6c47_s=3000x_.jpeg);
    }
  
    `}>
          
          <ColumnWrap className="column__flex js-anim  --anim6 --anim-s5 --center el--1" anim={"6"} animS={"5"} columns={"1"}>
            
            <ColumnWrapper style={{"paddingTop":0,"paddingBottom":0}}>
              
              <Button className="btn-box btn-box--hvr5 btn-box--cbtn2 btn-box--sbtn1 btn-box--pbtn3 btn-box--cColor2 btn-box--filling2 btn-box--center ls--12 lh--1" innerClassName="" url={"mailto:palkova.luca@gmail.com"} use={"mailto"} href={"mailto:palkova.luca@gmail.com"} style={{"paddingLeft":0}} content={"<span style=\"color: var(--white);\">KONTAKTOVAT</span>"}>
              </Button>

            </ColumnWrapper>

          </ColumnWrap>

        </Column>


        <Column className="--parallax" name={"uvod"} style={{"marginTop":0,"paddingTop":59,"marginBottom":0,"paddingBottom":58,"backgroundColor":"rgba(255, 255, 255, 1)"}} parallax={true} css={css`
      background-position: 45% 72%;
    `}>
          
          <ColumnWrap className="column__flex --center el--1 pb--0 pt--0" style={{"maxWidth":1410}} columns={"1"}>
            
            <ColumnWrapper className="pb--0 pt--0" style={{"maxWidth":1150}}>
              
              <Title className="title-box fs--24 swpf--uppercase ls--12 pb--0 pl--0 pr--0 pt--0" style={{"maxWidth":1118}} content={"<span style=\"color: rgb(5, 5, 5);\"><span style=\"font-weight: normal;\">Nabízím širokou škálu služeb v oblasti</span> grafického designu<span style=\"font-weight: normal;\">.</span></span><br>"}>
              </Title>

            </ColumnWrapper>

          </ColumnWrap>

        </Column>


        <Column name={"hhpcihmsgdu"} style={{"paddingTop":0,"paddingRight":0,"paddingBottom":0}} layout={"l8"}>
          
          <ColumnWrap className="column__flex --center el--1 flex--stretch" style={{"maxWidth":1678,"paddingLeft":0,"paddingRight":0}} columns={"1"}>
            
            <ColumnWrapper className="--center" style={{"maxWidth":1636,"paddingTop":0,"paddingBottom":0}}>
            </ColumnWrapper>

          </ColumnWrap>

        </Column>


        <Column className="css-1j2ds4f --parallax" name={"9pp5txwpunp"} style={{"paddingTop":0,"paddingRight":0,"paddingBottom":0}} layout={"l12"} parallax={true} css={css`
      
    background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=350x_.jpeg);
    @media (min-width: 351px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=660x_.jpeg);
    }
    @media (min-width: 661px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=860x_.jpeg);
    }
    @media (min-width: 861px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=1400x_.jpeg);
    }
    @media (min-width: 1401px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=2000x_.jpeg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (max-width: 350px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=660x_.jpeg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (min-width: 351px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=1400x_.jpeg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (min-width: 861px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=3000x_.jpeg);
    }
  
    `}>
          
          <ColumnWrap className="column__flex --center el--1 flex--stretch" style={{"maxWidth":1676,"paddingLeft":0,"paddingRight":0}} columns={"1"}>
            
            <ColumnWrapper className="js-anim  --anim6 --anim-s5" anim={"6"} animS={"5"} style={{"maxWidth":1518,"paddingTop":0}}>
              
              <Title className="title-box fs--22" style={{"maxWidth":1274,"marginTop":13,"paddingTop":12,"paddingBottom":12}} content={"<span style=\"font-weight: 400;\">On-line vizuály na sociální sítě k propagaci Boat Shows!</span><br>"}>
              </Title>

              <Image alt={"Obrázek editujete kliknutím"} src={"https://cdn.swbpg.com/t/23336/4c1945183dbd4987b4a7499b4ca7662f_e=263x157x3001x841_s=860x_.jpg"} sizes={"100vw"} style={{"maxWidth":1470}} srcSet={"https://cdn.swbpg.com/t/23336/4c1945183dbd4987b4a7499b4ca7662f_e=263x157x3001x841_s=350x_.jpg 350w, https://cdn.swbpg.com/t/23336/4c1945183dbd4987b4a7499b4ca7662f_e=263x157x3001x841_s=660x_.jpg 660w, https://cdn.swbpg.com/t/23336/4c1945183dbd4987b4a7499b4ca7662f_e=263x157x3001x841_s=860x_.jpg 860w, https://cdn.swbpg.com/t/23336/4c1945183dbd4987b4a7499b4ca7662f_e=263x157x3001x841_s=1400x_.jpg 1400w, https://cdn.swbpg.com/t/23336/4c1945183dbd4987b4a7499b4ca7662f_e=263x157x3001x841_s=2000x_.jpg 2000w"}>
              </Image>

            </ColumnWrapper>

            <ColumnWrapper style={{"maxWidth":518}}>
            </ColumnWrapper>

            <ColumnWrapper >
            </ColumnWrapper>

            <ColumnWrapper >
            </ColumnWrapper>

            <ColumnWrapper >
            </ColumnWrapper>

            <ColumnWrapper >
            </ColumnWrapper>

            <ColumnWrapper >
            </ColumnWrapper>

          </ColumnWrap>

          <ColumnWrap className="column__flex js-anim  --anim6 --anim-s5 --center el--3 flex--stretch" anim={"6"} animS={"5"} style={{"maxWidth":1540,"marginTop":0,"paddingLeft":0,"paddingRight":0}} columns={"3"}>
            
            <ColumnWrapper className="js-anim  --anim6 --anim-s5" anim={"6"} animS={"5"} style={{"maxWidth":536,"paddingTop":42}}>
              
              <Title className="title-box fs--22" style={{"maxWidth":1274,"paddingTop":8,"marginBottom":26}} content={"<span style=\"font-weight: normal;\">Fotomanipulace  postu s pozadím pro soc. sítě.</span><br>"}>
              </Title>

              <Image alt={"Obrázek editujete kliknutím"} src={"https://cdn.swbpg.com/t/23336/1a1dcd595234486aaa913224a3e9fea7_e=180x357x1279x1279_s=660x_.jpg"} sizes={"100vw"} style={{"maxWidth":435,"marginTop":48,"paddingLeft":0}} srcSet={"https://cdn.swbpg.com/t/23336/1a1dcd595234486aaa913224a3e9fea7_e=180x357x1279x1279_s=350x_.jpg 350w, https://cdn.swbpg.com/t/23336/1a1dcd595234486aaa913224a3e9fea7_e=180x357x1279x1279_s=660x_.jpg 660w, https://cdn.swbpg.com/t/23336/1a1dcd595234486aaa913224a3e9fea7_e=180x357x1279x1279_s=860x_.jpg 860w"}>
              </Image>

            </ColumnWrapper>

            <ColumnWrapper className="js-anim  --anim6 --anim-s5" anim={"6"} animS={"5"} style={{"maxWidth":440,"paddingTop":45}}>
              
              <Title className="title-box fs--22" style={{"maxWidth":1274,"paddingTop":0}} content={"<span style=\"font-weight: 400;\">Design tvořený přes Pipedrive pro mailing.</span><br>"}>
              </Title>

              <Image alt={"Obrázek editujete kliknutím"} src={"https://cdn.swbpg.com/t/23336/8910aed6479348dcb03980b248b55368_e=883x173x974x974_s=660x_.jpg"} sizes={"100vw"} style={{"maxWidth":438,"marginTop":53}} srcSet={"https://cdn.swbpg.com/t/23336/8910aed6479348dcb03980b248b55368_e=883x173x974x974_s=350x_.jpg 350w, https://cdn.swbpg.com/t/23336/8910aed6479348dcb03980b248b55368_e=883x173x974x974_s=660x_.jpg 660w, https://cdn.swbpg.com/t/23336/8910aed6479348dcb03980b248b55368_e=883x173x974x974_s=860x_.jpg 860w"}>
              </Image>

            </ColumnWrapper>

            <ColumnWrapper className="js-anim  --anim6 --anim-s5" anim={"6"} animS={"5"} style={{"maxWidth":438}}>
              
              <Title className="title-box fs--22" style={{"maxWidth":1274,"paddingTop":19}} content={"<span style=\"font-weight: normal;\">Kompletní design brandu HARMONY Jewellery. Letáky, samolepky, design krabiček na šperky a další.</span>"}>
              </Title>

              <Image alt={"Obrázek editujete kliknutím"} src={"https://cdn.swbpg.com/t/23336/58b9b783e96a49d886787e99bc4d9f51_e=247x0x1634x1634_s=860x_.jpg"} sizes={"100vw"} style={{"maxWidth":550}} srcSet={"https://cdn.swbpg.com/t/23336/58b9b783e96a49d886787e99bc4d9f51_e=247x0x1634x1634_s=350x_.jpg 350w, https://cdn.swbpg.com/t/23336/58b9b783e96a49d886787e99bc4d9f51_e=247x0x1634x1634_s=660x_.jpg 660w, https://cdn.swbpg.com/t/23336/58b9b783e96a49d886787e99bc4d9f51_e=247x0x1634x1634_s=860x_.jpg 860w, https://cdn.swbpg.com/t/23336/58b9b783e96a49d886787e99bc4d9f51_e=247x0x1634x1634_s=1400x_.jpg 1400w"}>
              </Image>

            </ColumnWrapper>

            <ColumnWrapper >
            </ColumnWrapper>

            <ColumnWrapper >
            </ColumnWrapper>

            <ColumnWrapper >
            </ColumnWrapper>

            <ColumnWrapper >
            </ColumnWrapper>

            <ColumnWrapper >
            </ColumnWrapper>

          </ColumnWrap>

        </Column>


        <Column className="css-1j2ds4f --parallax" name={"hhpcihmsgdu"} style={{"paddingTop":0,"paddingRight":0,"paddingBottom":0}} layout={"l8"} parallax={true} css={css`
      
    background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=350x_.jpeg);
    @media (min-width: 351px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=660x_.jpeg);
    }
    @media (min-width: 661px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=860x_.jpeg);
    }
    @media (min-width: 861px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=1400x_.jpeg);
    }
    @media (min-width: 1401px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=2000x_.jpeg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (max-width: 350px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=660x_.jpeg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (min-width: 351px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=1400x_.jpeg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (min-width: 861px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=3000x_.jpeg);
    }
  
    `}>
          
          <ColumnWrap className="column__flex --center el--1 flex--stretch" style={{"maxWidth":1464,"paddingLeft":0,"paddingRight":0}} columns={"1"}>
            
            <ColumnWrapper className="js-anim  --anim6 --anim-s5 --center" anim={"6"} animS={"5"} style={{"maxWidth":1636,"paddingTop":0,"paddingBottom":0}}>
              
              <Title className="title-box fs--22" style={{"maxWidth":1274,"paddingTop":25,"marginBottom":26}} content={"<span style=\"font-weight: normal;\">Kompletní design trička a polep motorového surfboardu JETSURF, pro závodníka Lukáše Záhorského a jeho tým.</span>"}>
              </Title>

              <Image alt={"Obrázek editujete kliknutím"} src={"https://cdn.swbpg.com/t/23336/c824a7965c1d43959f91d1f0d01da8eb_e=162x553x2162x625_s=860x_.jpg"} sizes={"100vw"} srcSet={"https://cdn.swbpg.com/t/23336/c824a7965c1d43959f91d1f0d01da8eb_e=162x553x2162x625_s=350x_.jpg 350w, https://cdn.swbpg.com/t/23336/c824a7965c1d43959f91d1f0d01da8eb_e=162x553x2162x625_s=660x_.jpg 660w, https://cdn.swbpg.com/t/23336/c824a7965c1d43959f91d1f0d01da8eb_e=162x553x2162x625_s=860x_.jpg 860w, https://cdn.swbpg.com/t/23336/c824a7965c1d43959f91d1f0d01da8eb_e=162x553x2162x625_s=1400x_.jpg 1400w, https://cdn.swbpg.com/t/23336/c824a7965c1d43959f91d1f0d01da8eb_e=162x553x2162x625_s=2000x_.jpg 2000w"}>
              </Image>

            </ColumnWrapper>

          </ColumnWrap>

        </Column>


        <Column className="css-1j2ds4f --parallax" name={"9pp5txwpunp"} style={{"paddingTop":0,"marginBottom":0,"paddingRight":0,"paddingBottom":0}} layout={"l12"} parallax={true} css={css`
      
    background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=350x_.jpeg);
    @media (min-width: 351px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=660x_.jpeg);
    }
    @media (min-width: 661px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=860x_.jpeg);
    }
    @media (min-width: 861px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=1400x_.jpeg);
    }
    @media (min-width: 1401px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=2000x_.jpeg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (max-width: 350px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=660x_.jpeg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (min-width: 351px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=1400x_.jpeg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (min-width: 861px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=3000x_.jpeg);
    }
  
    `}>
          
          <ColumnWrap className="column__flex --center el--3 pr--06 flex--stretch" style={{"maxWidth":1524,"paddingLeft":0}} columns={"3"}>
            
            <ColumnWrapper className="js-anim  --anim6 --anim-s5" anim={"6"} animS={"5"} style={{"maxWidth":630,"paddingTop":21}}>
              
              <Title className="title-box fs--22" style={{"maxWidth":1274,"paddingTop":0}} content={"<span style=\"font-weight: normal;\">Vánoční post na TIP s dárky.</span><br>"}>
              </Title>

              <Image alt={"Obrázek editujete kliknutím"} src={"https://cdn.swbpg.com/t/23336/5b97919d6a6e47f1a1efbbc2ae291e86_e=481x292x1046x1046_s=660x_.jpg"} sizes={"100vw"} style={{"maxWidth":446,"marginTop":23}} srcSet={"https://cdn.swbpg.com/t/23336/5b97919d6a6e47f1a1efbbc2ae291e86_e=481x292x1046x1046_s=350x_.jpg 350w, https://cdn.swbpg.com/t/23336/5b97919d6a6e47f1a1efbbc2ae291e86_e=481x292x1046x1046_s=660x_.jpg 660w, https://cdn.swbpg.com/t/23336/5b97919d6a6e47f1a1efbbc2ae291e86_e=481x292x1046x1046_s=860x_.jpg 860w"}>
              </Image>

            </ColumnWrapper>

            <ColumnWrapper className="js-anim  --anim6 --anim-s5" anim={"6"} animS={"5"} style={{"maxWidth":466,"paddingTop":21}}>
              
              <Title className="title-box fs--22" style={{"maxWidth":1274,"paddingTop":0}} content={"<span style=\"font-weight: normal;\">On-line postery pro soc.sítě na BLACK FRIDAY.</span><br>"}>
              </Title>

              <Image alt={"Obrázek editujete kliknutím"} src={"https://cdn.swbpg.com/t/23336/161c80b303354edaac33b13d8649842e_e=273x38x1685x1685_s=860x_.jpg"} sizes={"100vw"} style={{"maxWidth":446,"marginTop":23,"paddingLeft":0,"marginBottom":0,"paddingBottom":0}} srcSet={"https://cdn.swbpg.com/t/23336/161c80b303354edaac33b13d8649842e_e=273x38x1685x1685_s=350x_.jpg 350w, https://cdn.swbpg.com/t/23336/161c80b303354edaac33b13d8649842e_e=273x38x1685x1685_s=660x_.jpg 660w, https://cdn.swbpg.com/t/23336/161c80b303354edaac33b13d8649842e_e=273x38x1685x1685_s=860x_.jpg 860w, https://cdn.swbpg.com/t/23336/161c80b303354edaac33b13d8649842e_e=273x38x1685x1685_s=1400x_.jpg 1400w"}>
              </Image>

            </ColumnWrapper>

            <ColumnWrapper className="js-anim  --anim6 --anim-s5" anim={"6"} animS={"5"} style={{"maxWidth":520,"paddingTop":11}}>
              
              <Title className="title-box fs--22" style={{"maxWidth":1274,"paddingTop":8,"marginBottom":26}} content={"<span style=\"font-weight: 400;\">Fotomanipulace postu pro soc. sítě.</span><br>"}>
              </Title>

              <Image alt={"Obrázek editujete kliknutím"} src={"https://cdn.swbpg.com/t/23336/ab7751a1171e4aaba67f4735061bd626_e=366x52x1296x1296_s=660x_.jpg"} sizes={"100vw"} style={{"maxWidth":444,"marginTop":23,"paddingLeft":0,"paddingBottom":1}} srcSet={"https://cdn.swbpg.com/t/23336/ab7751a1171e4aaba67f4735061bd626_e=366x52x1296x1296_s=350x_.jpg 350w, https://cdn.swbpg.com/t/23336/ab7751a1171e4aaba67f4735061bd626_e=366x52x1296x1296_s=660x_.jpg 660w, https://cdn.swbpg.com/t/23336/ab7751a1171e4aaba67f4735061bd626_e=366x52x1296x1296_s=860x_.jpg 860w"}>
              </Image>

            </ColumnWrapper>

            <ColumnWrapper style={{"maxWidth":518}}>
            </ColumnWrapper>

            <ColumnWrapper >
            </ColumnWrapper>

            <ColumnWrapper >
            </ColumnWrapper>

            <ColumnWrapper >
            </ColumnWrapper>

            <ColumnWrapper >
            </ColumnWrapper>

          </ColumnWrap>

        </Column>


        <Column name={"za52xqr7ohj"} style={{"paddingRight":0}} layout={"l12"}>
        </Column>


        <Column name={"d0i1ctaxo6i"} style={{"paddingTop":0,"paddingBottom":0}} layout={"l29"}>
        </Column>


        <Column className="css-1j2ds4f --parallax" name={"wm4a8nrizp"} style={{"paddingTop":0,"paddingBottom":0}} layout={"l29"} parallax={true} css={css`
      
    background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=350x_.jpeg);
    @media (min-width: 351px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=660x_.jpeg);
    }
    @media (min-width: 661px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=860x_.jpeg);
    }
    @media (min-width: 861px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=1400x_.jpeg);
    }
    @media (min-width: 1401px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=2000x_.jpeg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (max-width: 350px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=660x_.jpeg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (min-width: 351px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=1400x_.jpeg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (min-width: 861px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=3000x_.jpeg);
    }
  
    `}>
          
          <ColumnWrap className="column__flex --center" style={{"maxWidth":1488,"paddingLeft":0,"paddingRight":0}}>
            
            <ColumnWrapper className="js-anim  --anim6 --anim-s5" anim={"6"} animS={"5"} style={{"maxWidth":909}}>
              
              <Title className="title-box fs--22" style={{"maxWidth":1274,"paddingTop":16}} content={"<span style=\"font-weight: normal;\">Katalog produktů Winni's Naturel</span><br>"}>
              </Title>

              <Image alt={"Obrázek editujete kliknutím"} src={"https://cdn.swbpg.com/t/23336/ec775b6d6da14a1c8bd4d135fbfa99fc_s=860x_.jpg"} sizes={"100vw"} style={{"maxWidth":915,"paddingLeft":0}} WrapIn={"square"} srcSet={"https://cdn.swbpg.com/t/23336/ec775b6d6da14a1c8bd4d135fbfa99fc_s=350x_.jpg 350w, https://cdn.swbpg.com/t/23336/ec775b6d6da14a1c8bd4d135fbfa99fc_s=660x_.jpg 660w, https://cdn.swbpg.com/t/23336/ec775b6d6da14a1c8bd4d135fbfa99fc_s=860x_.jpg 860w, https://cdn.swbpg.com/t/23336/ec775b6d6da14a1c8bd4d135fbfa99fc_s=1400x_.jpg 1400w, https://cdn.swbpg.com/t/23336/ec775b6d6da14a1c8bd4d135fbfa99fc_s=2000x_.jpg 2000w"} RootClassName={"column__pic"}>
              </Image>

            </ColumnWrapper>

            <ColumnWrapper className="js-anim  --anim6 --anim-s5" anim={"6"} animS={"5"} style={{"maxWidth":506,"paddingLeft":0}}>
              
              <Title className="title-box fs--22" style={{"maxWidth":1274,"paddingTop":16}} content={"<span style=\"font-weight: normal;\">Návrh vizualizace webu Carnode.</span><br>"}>
              </Title>

              <Image alt={"Obrázek editujete kliknutím"} src={"https://cdn.swbpg.com/t/23336/49935ad1b7694995bea66d7cb55a38b2_e=510x284x1291x1078_s=660x_.jpg"} sizes={"100vw"} style={{"maxWidth":562,"paddingLeft":0,"marginBottom":2,"paddingBottom":12}} WrapIn={"square"} srcSet={"https://cdn.swbpg.com/t/23336/49935ad1b7694995bea66d7cb55a38b2_e=510x284x1291x1078_s=350x_.jpg 350w, https://cdn.swbpg.com/t/23336/49935ad1b7694995bea66d7cb55a38b2_e=510x284x1291x1078_s=660x_.jpg 660w, https://cdn.swbpg.com/t/23336/49935ad1b7694995bea66d7cb55a38b2_e=510x284x1291x1078_s=860x_.jpg 860w"} RootClassName={"column__pic"}>
              </Image>

            </ColumnWrapper>

            <ColumnWrapper className="js-anim  --anim6 --anim-s5" anim={"6"} animS={"5"}>
              
              <Title className="title-box fs--22" style={{"maxWidth":1274,"paddingTop":0}} content={"<span style=\"font-weight: normal;\">Design polepu dodávky pro VALZET - prodej a servis zemědělské techniky.</span>"}>
              </Title>

              <Image alt={"Obrázek editujete kliknutím"} src={"https://cdn.swbpg.com/t/23336/ccccecb8b4434da98b4e80328496e906_e=209x172x1330x883_s=660x_.jpg"} sizes={"100vw"} style={{"maxWidth":508,"marginTop":23,"paddingLeft":0,"paddingBottom":12}} WrapIn={"square"} srcSet={"https://cdn.swbpg.com/t/23336/ccccecb8b4434da98b4e80328496e906_e=209x172x1330x883_s=350x_.jpg 350w, https://cdn.swbpg.com/t/23336/ccccecb8b4434da98b4e80328496e906_e=209x172x1330x883_s=660x_.jpg 660w, https://cdn.swbpg.com/t/23336/ccccecb8b4434da98b4e80328496e906_e=209x172x1330x883_s=860x_.jpg 860w"} RootClassName={"column__pic"}>
              </Image>

            </ColumnWrapper>

            <ColumnWrapper className="js-anim  --anim6 --anim-s5" anim={"6"} animS={"5"}>
              
              <Title className="title-box fs--22" style={{"maxWidth":1274,"marginTop":21,"paddingTop":0,"marginBottom":36,"paddingBottom":0}} content={"<span style=\"font-weight: normal;\">Design polepu motorized surfboard JETSURF pro Invictus Yacht.</span>"}>
              </Title>

              <Image alt={"Obrázek editujete kliknutím"} src={"https://cdn.swbpg.com/t/23336/a1f9e933e4c7429a96abbf6f780ac227_e=93x568x1827x872_s=860x_.jpg"} sizes={"100vw"} style={{"maxWidth":911,"marginTop":32,"paddingTop":0,"paddingLeft":0,"paddingBottom":0}} WrapIn={"square"} srcSet={"https://cdn.swbpg.com/t/23336/a1f9e933e4c7429a96abbf6f780ac227_e=93x568x1827x872_s=350x_.jpg 350w, https://cdn.swbpg.com/t/23336/a1f9e933e4c7429a96abbf6f780ac227_e=93x568x1827x872_s=660x_.jpg 660w, https://cdn.swbpg.com/t/23336/a1f9e933e4c7429a96abbf6f780ac227_e=93x568x1827x872_s=860x_.jpg 860w, https://cdn.swbpg.com/t/23336/a1f9e933e4c7429a96abbf6f780ac227_e=93x568x1827x872_s=1400x_.jpg 1400w"} RootClassName={"column__pic"}>
              </Image>

            </ColumnWrapper>

          </ColumnWrap>

        </Column>


        <Column className="css-1j2ds4f --parallax" name={"hhpcihmsgdu"} style={{"paddingTop":0,"paddingRight":0,"paddingBottom":0}} layout={"l8"} parallax={true} css={css`
      
    background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=350x_.jpeg);
    @media (min-width: 351px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=660x_.jpeg);
    }
    @media (min-width: 661px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=860x_.jpeg);
    }
    @media (min-width: 861px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=1400x_.jpeg);
    }
    @media (min-width: 1401px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=2000x_.jpeg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (max-width: 350px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=660x_.jpeg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (min-width: 351px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=1400x_.jpeg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (min-width: 861px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=3000x_.jpeg);
    }
  
    `}>
          
          <ColumnWrap className="column__flex --center el--1 flex--stretch" style={{"maxWidth":1464,"paddingLeft":0,"paddingRight":0}} columns={"1"}>
            
            <ColumnWrapper className="js-anim  --anim6 --anim-s5 --center" anim={"6"} animS={"5"} style={{"maxWidth":1636,"paddingTop":0,"paddingBottom":0}}>
              
              <Title className="title-box fs--22" style={{"maxWidth":1274,"paddingTop":14}} content={"<span style=\"font-weight: normal;\">On-line vizuál na stavební veletrh FOR ARCH pro divizi PF Group.</span><br>"}>
              </Title>

              <Image alt={"Obrázek editujete kliknutím"} src={"https://cdn.swbpg.com/t/23336/fdf9891e6d95406f867a0c87f38ec6ed_e=0x0x2580x689_s=860x_.jpg"} sizes={"100vw"} style={{"maxWidth":1469}} srcSet={"https://cdn.swbpg.com/t/23336/fdf9891e6d95406f867a0c87f38ec6ed_e=0x0x2580x689_s=350x_.jpg 350w, https://cdn.swbpg.com/t/23336/fdf9891e6d95406f867a0c87f38ec6ed_e=0x0x2580x689_s=660x_.jpg 660w, https://cdn.swbpg.com/t/23336/fdf9891e6d95406f867a0c87f38ec6ed_e=0x0x2580x689_s=860x_.jpg 860w, https://cdn.swbpg.com/t/23336/fdf9891e6d95406f867a0c87f38ec6ed_e=0x0x2580x689_s=1400x_.jpg 1400w, https://cdn.swbpg.com/t/23336/fdf9891e6d95406f867a0c87f38ec6ed_e=0x0x2580x689_s=2000x_.jpg 2000w"}>
              </Image>

            </ColumnWrapper>

          </ColumnWrap>

        </Column>


        <Column className="css-1j2ds4f --parallax" name={"hhpcihmsgdu"} style={{"paddingTop":0,"paddingRight":0,"paddingBottom":0}} layout={"l8"} parallax={true} css={css`
      
    background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=350x_.jpeg);
    @media (min-width: 351px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=660x_.jpeg);
    }
    @media (min-width: 661px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=860x_.jpeg);
    }
    @media (min-width: 861px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=1400x_.jpeg);
    }
    @media (min-width: 1401px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=2000x_.jpeg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (max-width: 350px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=660x_.jpeg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (min-width: 351px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=1400x_.jpeg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (min-width: 861px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=3000x_.jpeg);
    }
  
    `}>
          
          <ColumnWrap className="column__flex --center el--1 flex--stretch" style={{"maxWidth":1464,"paddingLeft":0,"paddingRight":0}} columns={"1"}>
            
            <ColumnWrapper className="--center" style={{"maxWidth":1636,"paddingTop":0,"paddingBottom":0}}>
            </ColumnWrapper>

          </ColumnWrap>

        </Column>


        <Column className="css-1j2ds4f --parallax" name={"wm4a8nrizp"} style={{"paddingTop":0,"paddingBottom":0}} layout={"l29"} parallax={true} css={css`
      
    background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=350x_.jpeg);
    @media (min-width: 351px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=660x_.jpeg);
    }
    @media (min-width: 661px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=860x_.jpeg);
    }
    @media (min-width: 861px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=1400x_.jpeg);
    }
    @media (min-width: 1401px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=2000x_.jpeg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (max-width: 350px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=660x_.jpeg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (min-width: 351px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=1400x_.jpeg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (min-width: 861px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=3000x_.jpeg);
    }
  
    `}>
          
          <ColumnWrap className="column__flex --center" style={{"maxWidth":1486,"paddingLeft":0,"marginBottom":0,"paddingRight":0}}>
            
            <ColumnWrapper className="js-anim  --anim6 --anim-s5" anim={"6"} animS={"5"} style={{"maxWidth":910,"paddingLeft":0,"paddingRight":0}}>
              
              <Title className="title-box fs--22" style={{"maxWidth":1274,"paddingTop":16}} content={"<span style=\"font-weight: normal;\">Nástěnný kalendář JETSURF pro rok 2023.</span><br>"}>
              </Title>

              <Image alt={"Obrázek editujete kliknutím"} src={"https://cdn.swbpg.com/t/23336/49038a9acd3a4326aa09dd7e75209dd2_e=400x367x1730x871_s=860x_.jpg"} sizes={"100vw"} style={{"maxWidth":951,"paddingLeft":0,"marginBottom":0,"paddingBottom":0}} WrapIn={"square"} srcSet={"https://cdn.swbpg.com/t/23336/49038a9acd3a4326aa09dd7e75209dd2_e=400x367x1730x871_s=350x_.jpg 350w, https://cdn.swbpg.com/t/23336/49038a9acd3a4326aa09dd7e75209dd2_e=400x367x1730x871_s=660x_.jpg 660w, https://cdn.swbpg.com/t/23336/49038a9acd3a4326aa09dd7e75209dd2_e=400x367x1730x871_s=860x_.jpg 860w, https://cdn.swbpg.com/t/23336/49038a9acd3a4326aa09dd7e75209dd2_e=400x367x1730x871_s=1400x_.jpg 1400w"} RootClassName={"column__pic"}>
              </Image>

            </ColumnWrapper>

            <ColumnWrapper className="js-anim  --anim6 --anim-s5" anim={"6"} animS={"5"} style={{"maxWidth":519,"paddingLeft":0,"paddingRight":0}}>
              
              <Title className="title-box fs--22" style={{"maxWidth":1274,"paddingTop":16}} content={"<span style=\"font-weight: normal;\">Vizuální posty COMING SOON na sociální sítě.</span><br>"}>
              </Title>

              <Image alt={"Obrázek editujete kliknutím"} src={"https://cdn.swbpg.com/t/23336/7fad05e732014210b0ffc39fa23d226e_e=43x171x1928x1425_s=860x_.jpg"} sizes={"100vw"} style={{"maxWidth":528,"paddingLeft":0,"marginBottom":0,"paddingBottom":0}} WrapIn={"square"} srcSet={"https://cdn.swbpg.com/t/23336/7fad05e732014210b0ffc39fa23d226e_e=43x171x1928x1425_s=350x_.jpg 350w, https://cdn.swbpg.com/t/23336/7fad05e732014210b0ffc39fa23d226e_e=43x171x1928x1425_s=660x_.jpg 660w, https://cdn.swbpg.com/t/23336/7fad05e732014210b0ffc39fa23d226e_e=43x171x1928x1425_s=860x_.jpg 860w, https://cdn.swbpg.com/t/23336/7fad05e732014210b0ffc39fa23d226e_e=43x171x1928x1425_s=1400x_.jpg 1400w"} RootClassName={"column__pic"}>
              </Image>

            </ColumnWrapper>

            <ColumnWrapper >
            </ColumnWrapper>

          </ColumnWrap>

        </Column>


        <Column name={"5tps5uff7jq"} style={{"paddingTop":0,"paddingBottom":0}} layout={"l8"}>
          
          <ColumnWrap className="column__flex --center el--1 flex--stretch" style={{"maxWidth":1676,"paddingLeft":5,"paddingRight":0}} columns={"1"}>
          </ColumnWrap>

        </Column>


        <Column className="css-1j2ds4f --center --parallax" name={"7l9os73fr2x"} style={{"marginTop":0,"paddingTop":79,"paddingBottom":42}} parallax={true} css={css`
      
    background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=350x_.jpeg);
    @media (min-width: 351px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=660x_.jpeg);
    }
    @media (min-width: 661px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=860x_.jpeg);
    }
    @media (min-width: 861px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=1400x_.jpeg);
    }
    @media (min-width: 1401px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=2000x_.jpeg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (max-width: 350px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=660x_.jpeg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (min-width: 351px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=1400x_.jpeg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (min-width: 861px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=3000x_.jpeg);
    }
  
    `}>
          
          <ColumnWrap className="column__flex --center el--1" columns={"1"}>
            
            <ColumnWrapper className="--left">
              
              <Title className="title-box title-box--center fs--48 swpf--uppercase ls--12" style={{"maxWidth":978,"paddingTop":0}} content={"<span style=\"font-weight: normal;\">Vybrané reference</span>"}>
              </Title>

            </ColumnWrapper>

          </ColumnWrap>

        </Column>


        <Column className="css-1j2ds4f --parallax" name={"kskzwl8lu"} style={{"paddingTop":0,"paddingBottom":69}} layout={"l8"} parallax={true} css={css`
      
    background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=350x_.jpeg);
    @media (min-width: 351px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=660x_.jpeg);
    }
    @media (min-width: 661px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=860x_.jpeg);
    }
    @media (min-width: 861px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=1400x_.jpeg);
    }
    @media (min-width: 1401px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=2000x_.jpeg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (max-width: 350px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=660x_.jpeg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (min-width: 351px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=1400x_.jpeg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (min-width: 861px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=3000x_.jpeg);
    }
  
    `}>
          
          <ColumnWrap className="column__flex js-anim  --anim6 --anim-s5 --center el--4 flex--center" anim={"6"} animS={"5"} style={{"maxWidth":1280,"marginTop":0,"paddingTop":18,"marginBottom":0,"paddingBottom":20}} columns={"4"}>
            
            <ColumnWrapper style={{"paddingTop":38,"paddingBottom":40}}>
              
              <Image alt={"Obrázek editujete kliknutím"} src={"https://cdn.swbpg.com/o/23336/3599ab3b606e489ba384b89c6b4d3052.svg"} url={"https://jetsurf.com/"} use={"url"} href={"https://jetsurf.com/"} sizes={"100vw"} style={{"maxWidth":180,"paddingTop":0}} srcSet={""} lightbox={false}>
              </Image>

            </ColumnWrapper>

            <ColumnWrapper >
              
              <Image alt={"Obkliknutímrázek editujete "} src={"https://cdn.swbpg.com/o/23336/c8fd5e8014914d1082a6437f7b314e07.svg"} url={"https://harmony.ipoukaz.cz/"} use={"url"} href={"https://harmony.ipoukaz.cz/"} sizes={"100vw"} style={{"maxWidth":159}} srcSet={""} lightbox={false}>
              </Image>

            </ColumnWrapper>

            <ColumnWrapper className="pb--20 pt--20">
              
              <Image alt={"Obrázek editujete kliknutím"} src={"https://cdn.swbpg.com/o/23336/199ffd9680a44df7bb1a1c9374bd2ac7.svg"} url={"http://www.pfgroup.cz/"} use={"url"} href={"http://www.pfgroup.cz/"} sizes={"100vw"} style={{"maxWidth":180,"marginTop":0,"paddingTop":0}} srcSet={""} lightbox={false}>
              </Image>

            </ColumnWrapper>

            <ColumnWrapper className="pb--20 pt--20">
              
              <Image alt={"Obrázek editujete kliknutím"} src={"https://cdn.swbpg.com/o/23336/051e2b7140d24e3694892d5c72548d59.png"} url={"http://www.pfgroup.cz/"} use={"url"} href={"http://www.pfgroup.cz/"} sizes={"100vw"} style={{"maxWidth":218,"marginTop":0,"paddingTop":0}} srcSet={""} lightbox={false}>
              </Image>

            </ColumnWrapper>

          </ColumnWrap>

        </Column>


        <Column anim={null} name={"kontakt"} style={{"marginTop":0,"paddingTop":85,"marginBottom":0,"paddingRight":0,"paddingBottom":93,"backgroundColor":"rgba(255, 255, 255, 1)"}}>
          
          <ColumnWrap className="column__flex js-anim  --anim2 --anim-s4 el--2 flex--top" anim={"2"} animS={"4"} style={{"maxWidth":1457,"paddingTop":0,"paddingLeft":2,"paddingRight":0,"paddingBottom":0}} columns={"2"}>
            
            <ColumnWrapper className="js-anim  --anim6 --anim-s5 --center" anim={"6"} animS={"5"} style={{"maxWidth":1340,"paddingTop":59,"paddingLeft":0,"paddingBottom":69}}>
              
              <Title className="title-box fs--30 w--900 pl--0 pr--0" style={{"maxWidth":"","paddingTop":0,"paddingBottom":0}} content={"<span style=\"color: rgb(2, 2, 2); font-weight: normal;\">Přečtěte si něco o mě..</span><br>"}>
              </Title>

              <Image className="--shadow4 --center" alt={"Pálková"} src={"https://cdn.swbpg.com/t/23336/1ab9f3a7382d4f70ac73ddf445bf8c29_e=161x424x1330x1330_s=660x_.jpg"} sizes={"100vw"} style={{"maxWidth":309}} srcSet={"https://cdn.swbpg.com/t/23336/1ab9f3a7382d4f70ac73ddf445bf8c29_e=161x424x1330x1330_s=350x_.jpg 350w, https://cdn.swbpg.com/t/23336/1ab9f3a7382d4f70ac73ddf445bf8c29_e=161x424x1330x1330_s=660x_.jpg 660w, https://cdn.swbpg.com/t/23336/1ab9f3a7382d4f70ac73ddf445bf8c29_e=161x424x1330x1330_s=860x_.jpg 860w"} lightbox={true}>
              </Image>

            </ColumnWrapper>

            <ColumnWrapper className="pb--0 pt--0" style={{"maxWidth":1150}}>
              
              <Text className="text-box text-box--left fs--18" style={{"maxWidth":745,"paddingTop":0,"paddingLeft":0,"paddingRight":0,"paddingBottom":0}} content={"<span style=\"color: rgb(89, 89, 89);\">Jsem grafická designérka v oblasti brandingu firem a tvorby vizuální identity značek. Mým hlavním zájmem je pomáhat firmám a značkám vytvářet efektivní vizuální komunikaci.\n<br>S praxí v oblasti grafického designu jsem vyvinula dovednosti v tvorbě veškerých tiskových materiálů a to i velkoplošných, custom i sériových polepů, navrhování stánků,&nbsp; a náhledového designu pro weby a v neposlední řadě kompletní on-line zpracování vizuálů na sociální sítě a jiné..<br>Věřím, že správná vizuální identita může posílit povědomí o značce a její důvěryhodnost. Snažím se chápat potřeby klienta a vytvořit pro něj účinné vizuální řešení.<br>Od předškolního věku jsem se začala věnovat malbě, kreslení a největší zálibu jsem měla v keramice. Ve škole jsem trávila všechen volný čas&nbsp;ve výtvarce, sportovních kroužcích a postupem času jsem dospívala k zálibám v tvorbě grafiky. Poté jsem vystudovala grafický obor s maturitou a od té doby dělám na projektech, které mi přináší radost, setkání se zajímavými lidmi a spokojené klienty.&nbsp;</span><br>"}>
              </Text>

            </ColumnWrapper>

          </ColumnWrap>

        </Column>


        <Column className="css-1j2ds4f --parallax" name={"siqbskj5atl"} style={{"marginTop":0,"paddingTop":56,"paddingBottom":75}} layout={"l5"} parallax={true} css={css`
      
    background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=350x_.jpeg);
    @media (min-width: 351px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=660x_.jpeg);
    }
    @media (min-width: 661px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=860x_.jpeg);
    }
    @media (min-width: 861px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=1400x_.jpeg);
    }
    @media (min-width: 1401px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=2000x_.jpeg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (max-width: 350px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=660x_.jpeg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (min-width: 351px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=1400x_.jpeg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (min-width: 861px) {
      background-image: url(https://cdn.swbpg.com/t/23336/8be5a0ff119546919011f5e30a3da392_s=3000x_.jpeg);
    }
  
    `}>
          
          <ColumnWrap className="column__flex --center el--1" columns={"1"}>
            
            <ColumnWrapper style={{"paddingBottom":0}}>
              
              <Title className="title-box fs--48 swpf--uppercase ls--12" content={"<span style=\"font-weight: normal;\">Kontaktovat</span>"}>
              </Title>

              <Text className="text-box" style={{"maxWidth":690,"marginTop":40}} content={"<span style=\"color: rgb(219, 219, 219);\">Pokud potřebujete designéra v oblasti brandingu a tvorby vizuální identity, nevájete se na mě obrátit.</span>"}>
              </Text>

            </ColumnWrapper>

          </ColumnWrap>

          <ColumnWrap className="column__flex js-anim  --anim6 --anim-s5 el--2 flex--stretch" anim={"6"} animS={"5"} style={{"maxWidth":1249}} columns={"2"} fullscreen={false}>
            
            <ColumnWrapper style={{"paddingRight":0}}>
              
              <FullmapCover zoom={"12"} place={"Brno, Vídeňská 1018/18a"} style={{"overflow":"hidden","borderRadius":"6px","paddingRight":0}}>
              </FullmapCover>

            </ColumnWrapper>

            <ColumnWrapper style={{"paddingLeft":0}}>
              
              <TitleMain className="title-box fs--16 swpf--uppercase ls--20" style={{"paddingBottom":11}} content={"Mail:"}>
              </TitleMain>

              <Button className="btn-box btn-box--hvr5 btn-box--cbtn2 btn-box--pbtn2 btn-box--cColor2 btn-box--filling2 fs--16" url={"mailto:palkova.luca@gmail.com"} use={"mailto"} href={"mailto:palkova.luca@gmail.com"} style={{"marginTop":9,"paddingBottom":14}} content={"<span style=\"color: var(--white);\">palkova.luca@gmail.com</span>"}>
              </Button>

              <Subtitle className="subtitle-box fs--16 swpf--uppercase ls--20" style={{"marginTop":13,"paddingBottom":11}} content={"Telefoní číslo:"}>
              </Subtitle>

              <Button className="btn-box btn-box--hvr5 btn-box--cbtn2 btn-box--pbtn2 btn-box--cColor2 btn-box--filling2 fs--16" url={"tel:+420736516181"} use={"tel"} href={"tel:+420736516181"} style={{"marginTop":10,"paddingBottom":11}} content={"<span style=\"color: var(--white);\">+420 736 516 181</span>"}>
              </Button>

              <Subtitle className="subtitle-box fs--16 swpf--uppercase ls--20" style={{"marginTop":16,"paddingBottom":14}} content={"Sociální sítě:"}>
              </Subtitle>

              <Button className="btn-box btn-box--hvr5 btn-box--cbtn2 btn-box--pbtn2 btn-box--cColor2 btn-box--filling2 fs--16" url={"https://cz.linkedin.com/in/lucie-p%C3%A1lkov%C3%A1-405758150?trk=people-guest_people_search-card"} use={"url"} href={"https://cz.linkedin.com/in/lucie-p%C3%A1lkov%C3%A1-405758150?trk=people-guest_people_search-card"} style={{"marginTop":6,"paddingBottom":10}} content={"<span style=\"color: var(--white);\">LinkedIn</span>"}>
              </Button>

            </ColumnWrapper>

          </ColumnWrap>

        </Column>

      </Layout>
    </ThemeWrapper>
  )
}